/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getCashtagProfile} from '../api'

 export const useQueryGetCashtagProfile = createReactQueryHook('getCashtagProfile', getCashtagProfile)
